import type {
  AgentDefinition,
  AgentFollowUp,
  AgentKnowledgeSource,
  AgentSkill,
  AgentSubAgent,
} from '@/stores/agentCatalogStore'

function serializeKnowledgeSource(source: AgentKnowledgeSource) {
  return {
    id: source.id,
    type: source.type,
    title: source.title,
    content: source.content,
    url: source.url,
    file_name: source.file_name,
    mime_type: source.mime_type,
    size_bytes: source.size_bytes,
  }
}

function serializeSkill(skill: AgentSkill) {
  return {
    id: skill.id,
    name: skill.name,
    quickstart: skill.quickstart,
    instructions: skill.instructions,
    request_enabled: skill.request_enabled,
    request_method: skill.request_method,
    request_url: skill.request_url,
    request_headers: skill.request_headers,
    request_body: skill.request_body,
    reference_source: skill.reference_source
      ? serializeKnowledgeSource(skill.reference_source)
      : null,
  }
}

function serializeSubAgent(subagent: AgentSubAgent) {
  return {
    id: subagent.id,
    name: subagent.name,
    objective: subagent.objective,
    prompt: subagent.prompt,
    personality: subagent.personality,
    knowledge_base: subagent.knowledge_base,
    skills: subagent.skills.map(serializeSkill),
    active: subagent.active ?? true,
  }
}

function serializeFollowUp(followup: AgentFollowUp) {
  return {
    id: followup.id,
    title: followup.title,
    delay_minutes: followup.delay_minutes,
    instructions: followup.instructions,
    active: followup.active,
  }
}

export function serializeAgentDefinitionForRuntime(agent: AgentDefinition) {
  return {
    id: agent.id,
    name: agent.name,
    supervisor_name: agent.supervisor_name,
    persona_name: agent.persona_name,
    personality: agent.personality,
    system_prompt: agent.system_prompt,
    knowledge_base: agent.knowledge_base,
    knowledge_sources: agent.knowledge_sources.map(serializeKnowledgeSource),
    enabled: agent.enabled,
    memory_enabled: agent.memory_enabled,
    strict_logic_flow: agent.strict_logic_flow,
    followups: agent.followups.map(serializeFollowUp),
    subagents: agent.subagents.map(serializeSubAgent),
    metadata: agent.metadata ?? {},
    created_at: agent.created_at,
    updated_at: new Date().toISOString(),
  }
}
